<template>
  <div class="container mt-5" v-if="page === 'register'">
  <form>
    <div class="form-group">
      <label>Full Name</label>
      <input type="text" class="form-control" v-model="name">
    </div>
    <div class="form-group">
      <label>Email address</label>
      <input type="email" class="form-control" v-model="email">
    </div>
    <div class="form-group">
      <label>Password</label>
      <input type="password" class="form-control" v-model="password">
    </div>
    <div class="form-group container row justify-content-between">
      <div class="col text-right">
        <span>already have an account?
        <button type="button" class="btn btn-md text-right border border-primary" @click="loginPage">Login</button></span>
      </div>
    </div>
    <button type="submit" class="btn btn-success" @click.prevent="register">Register</button>
  </form>
</div>
</template>
<script>
import axios from "axios"

export default {
  props: ['page'],
  data: function () {
    return {
      name: '',
      email: '',
      password: '',
    }
  },
  methods: {
    register: function(){
      axios.post('https://protected-taiga-35743.herokuapp.com/user/register', {
        name: this.name,
        email: this.email,
        password: this.password
      })
      .then(data => {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          onOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'success',
          title: 'Signup successfully'
        })
        this.$emit('changePage', {page: 'login'})
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',  
          title: 'Registration Failed',
          text: 'Make sure you have filled the form',
          position: 'top',
        })
        console.log(err)
      })
    },
    loginPage: function(){
      this.$emit('changePage', {page: 'login'})
    }
  }
}
</script>